import { AxiosPromise } from 'axios'

import {
  GetAllCustomerPayments,
  GetAllCustomerPaymentsTransaction,
  RefundRequestResponseType,
  RefundUserSubType,
  UpdateCustomerPayment
} from '../../types/api/faber/payment.type'
import OrbitApiV1 from '../orbitV1'

import FaberApi from '.'
class PaymentAPI {
  /**
   * to get the list of payments by all customers
   * @returns
   */
  static getAllCustomerPayments(
    faberToken: string,
    limit = 10,
    offset = 0,
    statusFilters: string[],
    paymentFilters: string[],
    planFilters: string[],
    searchCriteria: string,
    searchValue: string,
    sortDate: string,
    startAt: string,
    endAt: string
  ): AxiosPromise<GetAllCustomerPayments> {
    // TEMP UNTIL API IS FIXED
    if (planFilters.length === 0) {
      planFilters = ['Pro Pac', 'Lite Pac']
    }
    const status =
      statusFilters.length > 0 ? '&planStatuses=' + statusFilters.join(',') : ''

    const plan =
      planFilters.length > 0 ? '&planNames=' + planFilters.join(',') : ''

    const payment =
      paymentFilters.length > 0
        ? '&paymentStatuses=' + paymentFilters.join(',')
        : ''

    const dateRange =
      startAt && endAt ? `&startAt=${startAt}&endAt=${endAt}` : ''

    const orderBy = `&orderBy=${sortDate}`

    let email = ''
    let msisdn = ''
    switch (searchCriteria.toLowerCase()) {
      case 'email':
        email = searchValue.length > 0 ? `&email=${searchValue}` : ''
        break
      case 'msidn':
        msisdn = searchValue.length > 0 ? `&msisdns=${searchValue}` : ''
    }

    return FaberApi.httpGet(
      `/order/bill/all?limit=${limit}&offset=${offset}${status}${plan}${payment}${dateRange}${orderBy}${email}${msisdn}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
  /**
   * to get the list of payments by existing customers
   * @returns
   */
  static updatePaymentSuccess(body: UpdateCustomerPayment) {
    return FaberApi.httpPost(
      `/order/bill/paymentstatus`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getCustomerTransactions({
    customerId,
    limit = 5,
    offset = 0,
    order = 'desc'
  }: {
    customerId: string
    limit?: number
    offset?: number
    order?: string
  }): AxiosPromise<GetAllCustomerPaymentsTransaction> {
    return OrbitApiV1.httpGet(
      `/payment/transactions/${customerId}?limit=${limit}&offset=${offset}&order=${order}`
    )
  }
  static getGlobalCustomerTransactions({
    customerId,
    limit = 5,
    offset = 0,
    order = 'desc'
  }: {
    customerId: string
    limit?: number
    offset?: number
    order?: string
  }): AxiosPromise<GetAllCustomerPaymentsTransaction> {
    return OrbitApiV1.httpGet(
      `/payment/transactions/us/${customerId}?limit=${limit}&offset=${offset}&order=${order}`
    )
  }

  static refundUser(body: RefundUserSubType) {
    return FaberApi.httpPost(
      `/subscriptions/refund`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static refundUserV2(body: RefundUserSubType) {
    return FaberApi.httpPost(
      `/subscriptions/v2/refund`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getAllRefundRequests(
    offset = 0,
    limit = 10,
    faberToken: string,
    statuses?: string[], //RefundSuccess,RefundPending // please provide in this format (i.e. "string,string,string")
    searchKey?: string, //email,userID, iccid,msisdn
    searchValue?: string
  ): AxiosPromise<RefundRequestResponseType> {
    let convertedSearchCriteria = searchKey ? searchKey.toLowerCase() : ''

    if (searchKey === 'Customer ID') {
      convertedSearchCriteria = 'userID'
    }
    const searchQueryParam =
      searchKey && searchValue
        ? `&${convertedSearchCriteria}=${searchValue}`
        : ''
    const statusParam =
      statuses && statuses.length > 0 ? `&statuses=${statuses}` : ''
    return FaberApi.httpGet(
      `/subscriptions/refund?offset=${offset}&limit=${limit}${statusParam}${searchQueryParam}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
  /**
   * To change refund request from PENDING to SUCCESS
   */
  static updateRefundRequest({ faberToken, ID, refundPaymentId }) {
    return FaberApi.httpPost(
      `/subscriptions/refund/update`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        ID,
        refundPaymentId
      }
    )
  }

  /**
   * To change refund request from PENDING to SUCCESS v2 version
   */
  static updateRefundRequestV2({ faberToken, refundPaymentID }) {
    return FaberApi.httpPost(
      `/subscriptions/v2/refund/update`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        refundPaymentID
      }
    )
  }
  /**
   * To refund and terminate OTPACK
   */
  static terminateOtpackUponRefund({
    faberToken,
    refundPaymentID,
    refundReason,
    userId,
    ticketId
  }) {
    return FaberApi.httpPost(
      `/subscriptions/v2/refund`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        refundPaymentID,
        refundReason,
        terminateSub: false,
        terminatePlan: true,
        ticketId,
        userId
      }
    )
  }
}

export default PaymentAPI
